import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { SvgIconComponent } from '@dmb/core';

import { CoBrandingService } from '../../../../services';
import { FocusService } from '../../../../services/focus.service';
import { SwitchClientComponent } from '../../../modal/switch-client/switch-client.component';
import { SearchComponent } from '../../../search/search.component';
import { MenuService } from '../menu.service';

@Component({
  selector: 'dmb-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.scss'],
  imports: [SearchComponent, SwitchClientComponent, SvgIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavHeaderComponent {
  private menuService = inject(MenuService);
  private focusService = inject(FocusService);
  private coBrandingService = inject(CoBrandingService);

  logo = this.coBrandingService.logo;
  coBrand = this.coBrandingService.coBrand;

  toggleIcon = computed(() => (this.menuService.mainMenuCollapsed() ? 'add' : 'remove'));

  async toggleMainMenu() {
    return this.menuService.toggleMenu();
  }

  async expandSearch($event: MouseEvent) {
    $event.stopPropagation();

    const collapsed = this.menuService.mainMenuCollapsed();
    if (collapsed) await this.toggleMainMenu();

    // 500ms delay because setting focus before the css transition completes
    // causes the whole menu to shift.
    setTimeout(() => this.focusService.setFocus('search'), 500);

    // this.menuService.setOrToggleActive('searchBar');
  }

  handleSearch(isSearching: boolean) {
    if (isSearching) this.menuService.setInactive();
  }
}
